import Vue from 'vue';
import { encodePathSegment } from '@/utils/url';

export default (id, cb) => {
  Vue.$http
    .get(`customers/${encodePathSegment(id)}/addresses`)
    .then((response) => {
      cb(null, response);
    })
    .catch((error) => {
      cb(error);
    });
};



// WEBPACK FOOTER //
// ./src/services/customer/getAddress.js